import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=0c95fdf3&scoped=true"
import script from "./CartModal.vue?vue&type=script&lang=js"
export * from "./CartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95fdf3",
  null
  
)

export default component.exports